/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import t from"./Dictionary.js";class e extends t{constructor(t){super(),this.declaredClass="esri.arcade.Portal",this.immutable=!1,this.setField("url",t),this.immutable=!0}get url(){return this.field("url")}}export{e as default};
